
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-cda0ff3c&scoped=true!postcss!sass!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WorkLib.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./WorkLib.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-cda0ff3c!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WorkLib.vue"),
  /* scopeId */
  "data-v-cda0ff3c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/popularize/WorkLib.vue
// module id = 1108
// module chunks = 0